const constant = {
    "PARIKSHADOCURRENTUSER": "current_staff",
    "PARIKSHADOLOGGEDIN": "current_staff_logged_in",
    "COURSES": "course",
    ImageS3URl: "https://lunawatfoundation.com",
}

export default constant; 